import { useLoadingStore } from '~/stores/loading';

export default defineNuxtPlugin((nuxtApp) => {
  const loadingStore = useLoadingStore();
  // nuxtApp.vueApp.mixin({
  //   mounted() {
  //     loadingStore.startLoading();

  //     this.$nextTick(() => {
  //       loadingStore.stopLoading();
  //     })
  //   }
  // })
  // nuxtApp.hook('page:start', () => {
  //   loadingStore.startLoading();
  // })

  // nuxtApp.hook('page:finish', () => {
  //   requestAnimationFrame(() => {
  //   loadingStore.stopLoading();
  // })
  // })
});
